// extracted by mini-css-extract-plugin
export default {"container":"ViewProducts_container__v4Cfg","search":"ViewProducts_search__AJctz"};